module.exports = __webpack_public_path__ + "img/inventario_mobile.05ff4fd3.svg";